import EditIcon from '@mui/icons-material/Edit';
import {Button, DialogTitle, IconButton, TextField} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import {get} from 'lodash';
import {FC, Fragment, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useRecoilState} from 'recoil';
import {DocumentService} from '../../../../api/services/document.service';
import {ToastHelpers} from '../../../../shared/helpers/toastHelpers';
import {IDocument} from '../../../../shared/types/document.types';
import {editableWorkData} from '../../../../store/service-requests/atoms';

const BUTTON_SX = {width: 20, height: 20} as const;
const WITHOUT_ID_MESSAGE = 'У документа нет id';

interface Props {
  document?: IDocument;
  isPhoto?: boolean;
}

interface FormValues {
  description: string;
}

export const WorkDataInformationEdit: FC<Props> = ({document, isPhoto}) => {
  const defaultValues = {description: get(document, 'description', '')};
  const [{form}, setEditableWorkData] = useRecoilState(editableWorkData);
  const [modalOpen, setModalOpen] = useState(false);
  const formApi = useForm<FormValues>({defaultValues});

  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
  } = formApi;

  const handleShowDialog = () => {
    setModalOpen(true);
  };

  const handleCloseDialog = () => {
    setModalOpen(false);
    reset(defaultValues);
  };

  const handleFormSubmit = async ({description}: FormValues) => {
    try {
      if (!document?.id) throw new Error(WITHOUT_ID_MESSAGE);
      await DocumentService.updateDocumentDescription(document.id, description);
      setEditableWorkData({form, isDirty: true});
      handleCloseDialog();
    } catch (error) {
      ToastHelpers.error(error);
    }
  };

  if (!document) return null;

  return (
    <Fragment>
      <IconButton onClick={handleShowDialog} sx={BUTTON_SX}>
        <EditIcon fontSize="small" {...(isPhoto && {htmlColor: '#fff'})} />
      </IconButton>
      <Dialog open={modalOpen} onClose={handleCloseDialog} fullWidth>
        <DialogTitle>Обновить комментарий {document.fileName}</DialogTitle>
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <DialogContent>
            <TextField
              fullWidth
              placeholder="Введите комментарий"
              error={!!errors.description}
              {...register('description', {required: true})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Отмена</Button>
            <Button type="submit">Сохранить</Button>
          </DialogActions>
        </form>
      </Dialog>
    </Fragment>
  );
};
